<div
    class="icon"
    [mTooltip]="tooltip"
    [ngClass]="divClass"
    [ngStyle]="divStyle"
    [tooltipDisabled]="!tooltip || tooltipDisabled"
    [tooltipPosition]="tooltipPosition"
>
    @if (href) {
        <svg
            [ngClass]="ngClass"
            [ngStyle]="style"
        >
            <use [attr.href]="href"></use>
        </svg>
    }
</div>
